// default imports for react project
import React, { useLayoutEffect } from "react";

// import default style component from react-bootstrap package
import { Col, Container, Row } from "react-bootstrap";

// import dispatch hook to dispatch actions

// import function from actions
import { addCrumb } from "store/actions/common";

// import data from custom component
import { travelSuperiorPlan } from "./data";

//   import custom component
import { H1Grey, H2Grey } from "components/Heading";
import Accordion from "components/Accordion";
import BodyButton from "components/Buttons/BodyButton";
import BreadCrumb from "components/Breadcrumb";
import CardHeader from "components/Card/CardHeader";

// import util to get current window dimensions
import useWindowDimensions from "utils/useWindowDimension";

// import stylesheet
import Style from "./fastfacts.module.css";

// Import images from assets folder
import { card_header_img } from "assets/images/images";

// import classname package to combine module css and normal css
import classNames from "classnames";
import { RedirectToExternal } from "components/Heading";

import brochure from '../../assets/images/brochure.pdf';
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { setParam } from "utils/utils";


// React functional component starts here..
function FAQ() {
  // initialized dispatch using react hook
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const currentToken =  useSelector(state => state.auth.currentUserToken)

  // react layout hook to perform initial layout operations
  useLayoutEffect(() => {
    // scroll window to top of page on navigation
    window.scrollTo(0, 0);

    // dispatching an action to update breadcrumb
    dispatch(
      addCrumb([
        { link: "/faq", name: "FAQ" },
      ])
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function parseQuery(queryString) {
    var query = {};
    var pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
    for (var i = 0; i < pairs.length; i++) {
        var pair = pairs[i].split('=');
        query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
    }
    return query;
  }
 

  useEffect(() => {
    dispatch({type:"CURRENT_USER_TOKEN", payload:parseQuery(location.search).token ?? currentToken})
  },[])

  
  useEffect(() => {
    setParam(history,currentToken)
  },[currentToken])

  // Get width from util
  const { width } = useWindowDimensions();

  return (
    <div>
      <Container>
        <BreadCrumb />
        <Row className={classNames("mt-5")}>
          <H1Grey>
            <span className="text-danger">SureThing</span> Frequently Asked Questions
          </H1Grey>
          <H2Grey style={{fontWeight: 600}}>All-risk third-party legal liability</H2Grey>
        </Row>
        <Row className="mt-5 px-2">
          <Col lg={6} className={classNames("")}>
            <CardHeader
              image={card_header_img}
              title="FAQs"
              disableButton={true}
            />
          </Col>
          <Col lg={3}></Col>
          <Col className={Style.fbutton}>
            <BodyButton
              color="white"
              bg="#DA291C"
              name="Get Cover Now"
              size={20}
              marginL={0}
              weight={700}
              marginT={width > 770 ? 0 : 20}
              black={width > 770 ? false : true}
              link="/forms"
              id="faq-cover-now-button"
            />
          </Col>
        </Row>
        <Row className={classNames(Style.content__answer, "")}>
          <div className={classNames("mt-4")}>
            SureThing an all-in-one, all-risk third-party legal liability policy for small businesses.
          </div>
          
          <div className={`my-2 d-flex ${width < 770 ? 'flex-column align-items-center' : 'flex-row'} justify-content-start"`}>
            <RedirectToExternal target="_blank" style={{color: 'black', fontWeight: 800}} href="/sureThing-video">[ Watch Explainer Video ]</RedirectToExternal>
            <RedirectToExternal target="_blank" style={{marginLeft: width > 770 ? 20 : 0, color: 'black', fontWeight: 800}} href={brochure} >[ Download brochure ]</RedirectToExternal>
          </div>
        </Row>
        <Row>
          {travelSuperiorPlan?.map((plan, i) => (
            <Accordion key={i} title={plan?.title}>
              <div>
                {plan?.answer}
                <ul>
                  {plan?.subAnswer?.map((ans, i) => (
                    <li key={i}>{ans}</li>
                  ))}
                </ul>
              </div>
            </Accordion>
          ))}
        </Row>
      </Container>
    </div>
  );
}

export default FAQ;
